import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import AddStaffSkills from "./AddStaffSkills";
import { getStaffSkillList } from "../../CrudOperations/GetOperation";

const ManageStaffSkills = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredSkillList, setFilteredSkillList] = useState([]);
  const [SkillList, setSkillList] = useState([]);
  const [edit, setEdit] = useState("");

  useEffect(() => {
    const fetchStaffs = async () => {
      const response = await getStaffSkillList();
      if (response.data.Message === "Success") {
        setSkillList(response.data.Data);
        setFilteredSkillList(response.data.Data);
      } else {
        toast.error(response.data.ServerMessage);
      }
    };
    fetchStaffs();
  }, []);

  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredList = SkillList.filter((p) =>
      p.fullname?.toLowerCase().includes(query)
    );
    setFilteredSkillList(filteredList);
  };

  const handleUpdateStaff = (p) => {
    setEdit(p);
    setIsModalOpen(true);
  };

  const handleAddStaffformClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setEdit("");
    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    const response = await getStaffSkillList();
    if (response.data.Message === "Success") {
      setSkillList(response.data.Data);
      setFilteredSkillList(response.data.Data);
    }
    setIsModalOpen(false);
    toast.success("Skill added successfully!");
  };

  const handleUpdate = (newStaff) => {
    setSkillList((prev) =>
      prev.map((staff) => (staff.id === edit.id ? { ...staff, ...newStaff } : staff))
    );
    setFilteredSkillList((prev) =>
      prev.map((staff) => (staff.id === edit.id ? { ...staff, ...newStaff } : staff))
    );
    setEdit(null);
    closeModal();
  };

  return (
    <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg shadow-gray-300">
      <h1 className="text-xl font-bold mb-6 border-b-4 border-blue-600 pb-2 text-gray-800">
        Manage Deputy's Skills
      </h1>

      <div className="mb-6 flex justify-between items-center">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-1/2 border border-gray-300 p-3 rounded-md focus:ring-2 focus:ring-blue-500 shadow-sm"
        />

        <button
          onClick={handleAddStaffformClick}
          className="bg-blue-600 text-white px-6 py-2 rounded-md flex items-center gap-2 hover:bg-blue-700 hover:scale-105 shadow-md transition"
        >
          <FontAwesomeIcon icon={faPlus} />
          Add
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>
              {["S.No", "Deputy Name", "Skill Name", "Status", "Edit"].map((heading) => (
                <th key={heading} className="py-3 px-4 text-center font-semibold text-gray-700">
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredSkillList.length > 0 ? (
              filteredSkillList.map((p, index) => (
                <tr key={index} className="border-b hover:bg-gray-50 transition">
                  <td className="py-3 px-4 text-center">{index + 1}</td>
                  <td className="py-3 px-4 text-center">{p.fullname || "null"}</td>
                  <td
                    className="py-3 px-4 text-center text-blue-500 underline cursor-pointer"
                    onClick={() => setSelectedSkills(p)}
                  >
                    View Skills
                  </td>
                  <td className="py-3 px-4 text-center">{p.Status === 0 ? "Inactive" : "Active"}</td>
                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleUpdateStaff(p)}
                      className="text-blue-500 hover:text-blue-700"
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="py-3 text-center text-gray-600">
                  No staff found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Skills Modal */}
      {selectedSkills?.skillname?.length > 0 && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="relative bg-white rounded-lg p-6 w-[90%] max-w-md shadow-xl">
            <button
              className="absolute top-2 right-3 text-gray-600 hover:text-red-600 text-xl font-bold"
              onClick={() => setSelectedSkills(null)}
            >
              &times;
            </button>

            <h2 className="text-lg font-semibold mb-4 text-gray-800">
              Skills of {selectedSkills.fullname}
            </h2>

            <div className="flex flex-wrap gap-2">
              {selectedSkills.skillname.map((skill, index) => (
                <div
                  key={index}
                  className="px-3 py-1 bg-blue-100 text-blue-800 rounded-md text-sm font-medium"
                >
                  {skill}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Modal */}
      {isModalOpen && (
        <AddStaffSkills
          closeModal={closeModal}
          onSubmit={handleSubmit}
          StaffSkill={edit}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default ManageStaffSkills;
